export default "__VITE_ASSET__d3OtGCWq__"